import { LonaWebComponent, html } from "@tento-ui/component";
import { component } from "@tento-ui/component-decorators";
import { css } from "@tento-ui/component-styles";
import { Anchor } from "@tento-ui/components/anchor";
import { ContextMenu } from "@tento-ui/components/context-menu";

@component({
  name: "task-priority-indicator",
})
export class TaskPriorityIndicator extends LonaWebComponent {
  bind(priority?: Option<"high" | "medium" | "low">) {
    const level = this.getPriorityLevel(priority);
    this.setAttribute("priority", level.toString());

    // Update exclamation marks
    const $marks = this.$("marks");
    $marks.textContent = "!".repeat(level);
  }

  private getPriorityLevel(
    priority?: Option<"high" | "medium" | "low">,
  ): number {
    if (!priority) return 0;
    switch (priority) {
      case "high":
        return 3;
      case "medium":
        return 2;
      case "low":
        return 1;
    }
  }

  static $styles = [
    css`
      :host {
        display: flex;
        min-width: 24px;
        min-height: 24px;
        border-radius: 4px;
        --font-size: var(--small-size);
        font-weight: bold;
        user-select: none;
        cursor: pointer;
        transition: background-color 0.2s ease;
      }
      
      :host(:hover) {
        background-color: var(--bg-hover);
      }

      std-center {
        flex: 1;
      }

      :host([priority="1"]) {
        color: var(--green);
      }

      :host([priority="2"]) {
        color: var(--orange);
      }

      :host([priority="3"]) {
        color: var(--red);
      }

      #marks {
        letter-spacing: -1px;
      }
    `,
  ];

  static $html = html`
    <std-center>
      <span id="marks"></span>
    </std-center>
  `;
}

export namespace TaskPriorityIndicator {
  export type PriorityMenuId = "high" | "medium" | "low" | "none";

  export const MENU_ITEMS: Anchor.MenuItem<PriorityMenuId>[] = [
    { id: "high", label: "High Priority" },
    { id: "medium", label: "Medium Priority" },
    { id: "low", label: "Low Priority" },
    { id: "none", label: "No Priority" },
  ];

  export function buildMenu(
    onSelect: (id: PriorityMenuId) => void,
  ): ContextMenu.Built {
    const builder = ContextMenu.builder();
    for (const item of MENU_ITEMS) {
      builder.cellRow(item.label, null, (state) => {
        onSelect(item.id);
        state.shouldDismiss = true;
      });
    }
    return builder.build({ onDismiss: () => {} });
  }
}
